module.exports = __webpack_public_path__ + "img/104.379ce28c.png";